import { render } from "./BackOffice.vue?vue&type=template&id=b2ee30b4"
import script from "./BackOffice.vue?vue&type=script&lang=js"
export * from "./BackOffice.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__